import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Container } from '@/components/common/Container';
import { Section } from '@/components/common/Section';
import { theme } from '@/styles/theme';

const Title = styled.h1`
  margin-bottom: ${theme.spacing.xl};
`;

const BlogPostPage = () => {
  const { slug } = useParams();

  return (
    <Section $padding="large">
      <Container>
        <Title>Blog Post: {slug}</Title>
        <p>Coming soon...</p>
      </Container>
    </Section>
  );
};

export default BlogPostPage;
